"use strict";
import { ElementName, InterfaceEventName } from "uniswap/src/features/telemetry/constants";
import { sendAnalyticsEvent } from "uniswap/src/features/telemetry/send";
import { AppDownloadPlatform } from "uniswap/src/features/telemetry/types";
import { isWebAndroid, isWebIOS } from "utilities/src/platform";
const APP_DOWNLOAD_LINKS = {
  [ElementName.UniswapWalletModalDownloadButton]: "https://uniswapwallet.onelink.me/8q3y/qfwlncf9",
  [ElementName.UniswapWalletNavbarMenuDownloadButton]: "https://uniswapwallet.onelink.me/8q3y/46tvu6pb",
  [ElementName.UniswapWalletLandingPageDownloadButton]: "https://uniswapwallet.onelink.me/8q3y/79gveilz",
  [ElementName.UniswapWalletBannerDownloadButton]: "https://uniswapwallet.onelink.me/8q3y/jh9orof3"
};
export const MICROSITE_LINK = "https://wallet.uniswap.org/";
export function openDownloadApp({ element }) {
  if (isWebIOS) {
    openDownloadStore({ element, appPlatform: AppDownloadPlatform.Ios, linkTarget: "uniswap_wallet_appstore" });
  } else if (isWebAndroid) {
    openDownloadStore({ element, appPlatform: AppDownloadPlatform.Android, linkTarget: "uniswap_wallet_playstore" });
  } else {
    sendAnalyticsEvent(InterfaceEventName.UniswapWalletMicrositeOpened, { element });
    window.open(
      APP_DOWNLOAD_LINKS[element],
      /* target = */
      "uniswap_wallet_microsite"
    );
  }
}
const openDownloadStore = (options) => {
  sendAnalyticsEvent(InterfaceEventName.UniswapWalletAppDownloadOpened, {
    element: options.element,
    appPlatform: options.appPlatform
  });
  window.open(
    APP_DOWNLOAD_LINKS[options.element],
    /* target = */
    options.linkTarget
  );
};
